function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
/* eslint-disable @typescript-eslint/no-use-before-define */
import isEqual from 'lodash/isEqual';
import React, { useState } from 'react';
import { clsx } from 'clsx';
import { ButtonReact } from 'common/components/button';
import { ButtonSize, ButtonTheme } from 'common/components/button/constants';
import { Directions } from 'common/components/drop-menu/types';
import { getUpsellInfo, ModalTrigger } from 'common/widgets/in-product-upsell-modal/util';
import { SelectReact } from 'common/components/select';
import { SelectTheme } from 'common/components/select/constants';
import { ChangeEvent } from 'common/components/select/types';
import { DisplaySize, Placement } from 'common/components/tooltip/types';
import { renameEvent } from 'common/query-builder/cohorts-query-builder/util';
import { ControlBarAction, ControlBarActionItems, ControlBarActionValue } from 'common/query-builder/query-entry-section/constants';
import { EntryRowProps } from 'common/query-builder/query-entry-section/row-types/types';
import { Action, CountBy, Entry, EntryPart, EntrySectionUpdates, FiltersOperator, isMetricEntry, MetricEntry, MetricEntryBehavior, QueryEventEntry, QuerySuperEntry, RetentionCountType, RowLabelType, SelectorTypeDefinitions } from 'common/query-builder/query-entry-section/types';
import { CountUsersOnceState, ProjectFeatureFlag, ReportName, ResourceType } from 'common/report/constants';
import { ChartType, MetricType, MultiAttributionType, RETENTION_MATH_TYPES } from 'common/types/reports/bookmark';
import { RetentionAlignmentUpdate, RetentionBucketSizeUpdate, RetentionCohortizeUpdate, RetentionCriteriaReact, RetentionUnitUpdate } from 'common/query-builder/query-entry-section/row-types/metric-entry/metrics/retention/retention-criteria';
// eslint-disable-next-line import/no-cycle
import { QueryEntrySectionReact } from 'common/query-builder/query-entry-section';
import { EditControls } from 'common/query-builder/query-entry-section/components/edit-controls';
import { BaseEntryRow } from 'common/query-builder/query-entry-section/row-types/base';
import { getRetentionMetricAttributionItems } from 'common/report/insights/util/retention-attribution';
import { getEditCapability } from 'common/report/util/saved-entities';
import { MultiAttributionMenu } from 'common/widgets/multi-attribution-menu';
import { DefaultMultiAttribution } from 'common/widgets/multi-attribution-menu/constants';
import { MetricBehavior } from 'common/report/insights/util/types';
import { RowSelector } from 'common/query-builder/query-entry-section/components/selector';
import { BehaviorEntity as Behavior } from 'app_api/projects/behaviors/types';
import { getCountUsersOnceTypeFromEntrySelection } from 'common/query-builder/query-block/count-menu/util';
import { useBehaviors } from 'common/contexts/react/behaviors-context';
import { useCurrentProject } from 'common/contexts/react/current-project-context';
import { Translatable } from 'common/i18n';
import { useTranslation } from 'common/i18n/hooks';
import { getMultiAttributionFromEntry, isSupportedMultiAttributionTypeForEntry } from 'common/query-builder/query-builder/util';
import { getMultiAttributionLabel, getMultiAttributionTitle, getUpdatedMultiAttribution } from 'common/query-builder/query-entry-section/util/multi-attribution';
import { useMetrics } from 'common/contexts/react/metrics-resource-context';
import { setEntryVisibility } from 'common/query-builder/query-entry-section/row-types/row-util';
import { QueryEntrySectionTrackingEvent } from 'common/query-builder/query-entry-section/tracking';
import { CountQueryBlock } from 'common/query-builder/query-block/count-menu/count-query-block';
import { MenuType, MultiMetricsSectionItem } from 'common/query-builder/query-block/multi-metrics-menu/types';
import { MetricUnitsButton } from 'iron/common/query-builder/chart-customization/metric-units';
import { promptInProductUpsellModal } from 'common/widgets/in-product-upsell-modal/prompt';
import { CallingLocation } from 'common/query-builder/chart-customization/tracking';
import { currentProjectStore } from 'common/report/stores/project-details';
import { DataGroupSelect } from 'common/query-builder/data-group-select';
import { TopLevelMetricType } from 'common/types/reports/bookmark';
import { isModifiedEntryBehavior } from 'common/report/insights/util/events';
import { useDataGroups } from 'common/contexts/react/data-group-context';
import { SectionReact } from 'common/components/section';
import { getMetricEntryBehavior, isSavedBehavior, isSavedMetric, isUnsavedBehavior } from '../metric-entry-util';
import { EditableState, EditState, getFunnelOrRetentionDataGroupId, getTrackingProps, hasValidBehavior, saveBehavior } from '../behavior-utils';
import { canSaveForPlan, getNewEntry, getRetentionCountingMethod, hasSavedRetentionBehaviors } from './utils';
// eslint-disable-next-line import/no-cycle
import { helpers } from './helpers';
import { RetentionQuerySettingsReact } from './retention-query-settings';
import { RetentionQuerySettingsUpdate } from './types';
import styles from './index.module.styl';
export function RetentionMetricEntryRow(props: EntryRowProps<MetricEntry>) {
  var _currentProjectStore$;
  const [entryEl, setEntryEl] = useState<HTMLDivElement>(null);
  const [isExpanded, setIsExpanded] = useState<boolean>(true);
  const [isCreatingInline, setIsCreatingInline] = useState<boolean>(isExpanded && props.sectionProps.reportName === ReportName.Insights);
  const behaviors = useBehaviors();
  const currentProject = useCurrentProject();
  const i18n = useTranslation();
  const {
    t,
    print
  } = i18n;
  const hasFirstClassMetrics = (_currentProjectStore$ = currentProjectStore.value) === null || _currentProjectStore$ === void 0 ? void 0 : _currentProjectStore$.hasFeatureFlag(ProjectFeatureFlag.FirstClassMetrics);
  const isPlaceholder = helpers.isPlaceholder(props);
  const track = function track(event: QueryEntrySectionTrackingEvent) {
    let extraProps: Obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    props.dispatchTrack(event, _objectSpread(_objectSpread({}, props.getEntryTrackingProps()), extraProps));
  };
  const getEditState = (): EditState => {
    if (!canSaveForPlan(currentProject.get().value)) {
      return {
        showEditControls: false,
        saveDisabledMessage: "Cannot save retention metric with your current plan. [Learn more](https://mixpanel.com/pricing/)."
      };
    }
    const isSaving = behaviors.isLoading(props.entry.behavior.id);
    let canEdit = false;
    let canSave = true;
    let isSaved = false;
    let saveDisabledMessage = "";
    if (isSavedBehavior(props.entry)) {
      const behavior = behaviors.getOne(props.entry.behavior.id).value;
      canEdit = getEditCapability(behavior).enableEdit;
      isSaved = true;
      if (
      // behavior does not exists if the behavior is created and not shared by others
      behavior && !isModifiedEntryBehavior({
        behavior,
        entryBehavior: props.entry.behavior
      })) {
        canSave = false;
        saveDisabledMessage = t("query-builder.edit-controls.no-unsaved-changes");
      }
    }
    if (!hasValidBehavior(props.entry.behavior)) {
      canSave = false;
      saveDisabledMessage = t("query-builder.edit-controls.incomplete-behavior");
    }
    return {
      showEditControls: true,
      canEdit,
      canSave,
      isSaved,
      isSaving,
      saveDisabledMessage
    };
  };
  const handleControlSelect = (value: ControlBarActionValue) => {
    switch (value.action) {
      case ControlBarAction.Save:
        {
          const saveAsNew = isUnsavedBehavior(props.entry);
          handleSaveBehavior(saveAsNew, !saveAsNew);
          break;
        }
      case ControlBarAction.Show:
      case ControlBarAction.Hide:
        setEntryVisibility(props, value.action === ControlBarAction.Show);
        break;
      default:
        props.onControlSelect(value);
    }
  };
  const handleSelectSavedBehavior = function handleSelectSavedBehavior(behavior: Behavior) {
    let {
      isSaveExisting = false
    }: {
      isSaveExisting?: boolean;
      isExpanded?: boolean;
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    props.updateEntry(isSaveExisting ? Action.SaveBehavior : Action.Edit, _objectSpread(_objectSpread({}, props.entry), {}, {
      behavior: getMetricEntryBehavior({
        // ...behavior.definition.behavior,
        type: behavior.type,
        name: behavior.name,
        id: behavior.id
      } as MetricBehavior),
      hasUnsavedChanges: false
    }), {
      requery: true
    });
  };
  const handleCreateInline = (menuType: MenuType) => {
    setIsCreatingInline(true);
    props.onEntryRowCreate({
      type: SelectorTypeDefinitions.Metrics,
      event: null,
      filters: []
    }, menuType);
  };
  const handleSelectMultiMetrics = (item: MultiMetricsSectionItem) => {
    props.onEntryRowSelect({
      type: SelectorTypeDefinitions.Metrics,
      event: null,
      filters: []
    }, props.entry, item, props.index);
  };
  const handleSaveBehavior = async function handleSaveBehavior() {
    let saveAsNew = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    let previouslyExisting = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const {
      behavior
    } = props.entry;
    const {
      isCreating,
      results
    } = await saveBehavior({
      behavior,
      behaviors,
      currentProject,
      i18n,
      saveAsNew,
      previouslyExisting
    });
    if (!results) {
      return;
    }
    const newBehavior = Object.values(results)[0];
    if (isCreating) {
      track(QueryEntrySectionTrackingEvent.SaveBehavior, _objectSpread({
        'Save as New': saveAsNew
      }, getTrackingProps(props.entry)));
    } else {
      track(QueryEntrySectionTrackingEvent.SaveBehaviorChanges, _objectSpread({}, getTrackingProps(props.entry)));
    }
    handleSelectSavedBehavior(newBehavior, {
      isSaveExisting: !saveAsNew
    });
  };
  const handleReset = () => {
    if (isSavedBehavior(props.entry)) {
      track(QueryEntrySectionTrackingEvent.ResetBehavior, _objectSpread({}, getTrackingProps(props.entry)));
      const behavior = behaviors.getOne(props.entry.behavior.id).value;
      handleSelectSavedBehavior(behavior, {
        isExpanded: true
      });
    }
  };
  const handleDeleteEntry = () => {
    if (props.sectionProps.reportName === ReportName.Retention) {
      // reset to default state if it's /app/retention
      props.updateEntry(Action.Edit, getNewEntry({
        type: props.entry.behavior.type,
        isExpanded: true
      }));
      return;
    }
    props.removeEntry();
  };
  const metricButton = !props.isNestedSection ? <MetricUnitsButton callingLocation={CallingLocation.Metric} chartType={props.currentChartType} setEntry={entry => props.updateEntry(Action.Edit, entry as Entry, {
    requery: false
  })} showDefaultMetricUnitSelector={props.showDefaultMetricUnitSelector} insideFooter entry={props.entry} /> : null;
  const suffixRenderer = () => {
    return <>
        {isExpanded && <>
            <BehaviorBlock {...props} measurementBlock={hasFirstClassMetrics ? <MeasurementBlock {...props} metricUnitsButton={metricButton} /> : undefined} />
            {(() => {
          const editState = getEditState();
          if (props.entry.behavior.type === MetricType.Retention && editState.showEditControls) {
            return <EditControlsBlock entry={props.entry} handleSaveBehavior={handleSaveBehavior} handleReset={handleReset} editableState={editState} />;
          } else if (getUpsellInfo(currentProject.get().value, ModalTrigger.METRICS, i18n)) {
            return <div className='mp-metric-entry-edit-controls'>
                    <ButtonReact className='upsell-button' theme={ButtonTheme.Secondary} icon={"brand-upgrade"} onClick={() => promptInProductUpsellModal(ModalTrigger.METRICS)}>
                      {t("query-builder.actions.save-metric")}
                    </ButtonReact>
                  </div>;
          }
          return null;
        })()}
          </>}
        {!hasFirstClassMetrics && <MeasurementBlock {...props} metricUnitsButton={metricButton} />}
      </>;
  };
  const actionsRenderer = () => {
    if (props.disableCollapse) {
      return null;
    }
    return <ButtonReact className='expand-control' icon={isExpanded ? "collapse-diagonal" : "expand"} theme={ButtonTheme.Tertiary} size={ButtonSize.Medium} tooltip={{
      text: isExpanded ? t("query-builder.actions.collapse") : t("query-builder.actions.expand")
    }} onClick={() => setIsExpanded(!isExpanded)} data-sentry-element="ButtonReact" data-sentry-component="actionsRenderer" data-sentry-source-file="index.tsx" />;
  };
  const selectorRenderer = () => {
    let metricName: Translatable = props.entry.behavior.type === MetricType.RetentionFrequency ? "Untitled" : isCreatingInline ? t("query-builder.retention.label-new") : t("query-builder.retention.label-select");
    let isSaved = hasFirstClassMetrics && props.entry.type === TopLevelMetricType.Metric ? isSavedMetric(props.entry) : isSavedBehavior(props.entry);
    if (isSaved) {
      metricName = props.entry.name || props.entry.behavior.name || metricName;
      const behavior = behaviors.getOne(props.entry.behavior.id).value;
      isSaved = behavior ? !isModifiedEntryBehavior({
        behavior,
        entryBehavior: props.entry.behavior
      }) : false;
    } else {
      metricName = props.entry.behavior.renamed || props.entry.behavior.name || metricName;
    }
    if (props.entry.behavior.type === MetricType.RetentionFrequency || !canSaveForPlan(currentProject.get().value) && !hasSavedRetentionBehaviors({
      behaviors
    })) {
      return <div className='mp-metric-entry-header-name' title={print(metricName)}>
          <span className='metric-name'>{print(metricName)}</span>
        </div>;
    }
    return <div className={"mp-metric-entry-header-selector ".concat(isSaved ? "is-saved" : "")} data-sentry-component="selectorRenderer" data-sentry-source-file="index.tsx">
        {props.sectionProps.reportName === ReportName.Insights ? <RowSelector {...props} contextPanelParentElement={entryEl} isPlaceholder={isPlaceholder} selected={{
        menuType: MenuType.Retention,
        value: {
          id: props.entry.behavior.id,
          name: metricName
        }
      }} selectorType={SelectorTypeDefinitions.Metrics} onSelect={(sectionItem: MultiMetricsSectionItem) => handleSelectMultiMetrics(sectionItem)} onCreate={(ev: {
        detail: {
          item: MenuType;
        };
      }) => handleCreateInline(ev.detail.item)} /> : <RowSelector {...props} contextPanelParentElement={entryEl} isPlaceholder={isPlaceholder} selected={{
        id: props.entry.behavior.id,
        name: metricName
      }} queryBlockConfig={{
        type: "behaviors",
        metricType: MetricType.Retention
      }} onSelect={(selection: {
        item: Behavior;
      }) => {
        track(QueryEntrySectionTrackingEvent.SelectBehavior, _objectSpread({}, getTrackingProps(props.entry)));
        handleSelectSavedBehavior(selection.item);
      }} onCreate={() => handleCreateInline(MenuType.Retention)} />}
      </div>;
  };
  const {
    saveDisabledMessage
  } = getEditState();
  return <BaseEntryRow ref={setEntryEl} {...props} isPlaceholder={isPlaceholder} showLabels={props.sectionProps.reportName === ReportName.Insights} showDefaultMetricUnitSelector={false} extraEntryClass={{
    'is-metric': true
  }} renderSelector={selectorRenderer} renderSuffix={suffixRenderer} renderActions={actionsRenderer} onControlSelect={handleControlSelect} canAlwaysDelete onDeleteEntry={handleDeleteEntry} overflowControls={[...props.getCommonOverflowControls(), ControlBarActionItems[ControlBarAction.Rename], props.entry.behavior.type === MetricType.Retention && _objectSpread(_objectSpread({}, ControlBarActionItems[ControlBarAction.Save]), saveDisabledMessage ? {
    isDisabled: true,
    tooltip: {
      text: saveDisabledMessage
    }
  } : {}), ...(props.sectionProps.reportName === ReportName.Insights ? [ControlBarActionItems[ControlBarAction.Delete], !props.sectionProps.disableCloneEntry && ControlBarActionItems[ControlBarAction.Duplicate], props.sectionProps.enableHideEntry && ControlBarActionItems[props.entry.isHidden ? ControlBarAction.Show : ControlBarAction.Hide]].filter(Boolean) : [])].filter(Boolean)} data-sentry-element="BaseEntryRow" data-sentry-component="RetentionMetricEntryRow" data-sentry-source-file="index.tsx" />;
}
export function MeasurementBlock(props: EntryRowProps<MetricEntry> & {
  metricUnitsButton?: React.ReactNode;
}) {
  var _getRetentionMetricAt, _props$entry$behavior;
  const metrics = useMetrics();
  const behaviors = useBehaviors();
  const {
    t,
    print
  } = useTranslation();
  const dataGroupStore = useDataGroups();
  const showMetricDataGroupSelect = props.sectionProps.metricLevelDataGroups;
  const dataGroupId = getFunnelOrRetentionDataGroupId({
    props
  });
  const handleRetentionCountBySelected = (countBy: CountBy) => {
    const measurement = props.entry.measurement;
    measurement.aggregationOperator = countBy.aggregationOperator;
    measurement.countUsersOnceType = getCountUsersOnceTypeFromEntrySelection({
      selectedCountUsersOnceType: countBy.countUsersOnceType,
      metricType: MetricType.Retention,
      multiAttribution: measurement.multiAttribution
    });
    measurement.property = countBy.property;
    const entry = _objectSpread(_objectSpread({}, props.entry), {}, {
      measurement
    });
    props.updateEntry(Action.Edit, entry);
    props.dispatchTrack(QueryEntrySectionTrackingEvent.SelectNumericAggregator, _objectSpread(_objectSpread({}, props.getEntryTrackingProps()), {}, {
      Aggregator: countBy.aggregationOperator
    }, countBy.property && {
      'Property name': countBy.property.label,
      'Property data type': "type" in countBy.property ? countBy.property.type : null
    }));
  };
  const handleRetentionBucketIndexSelected = (ev: ChangeEvent<number>) => {
    const retentionBucketIndex = ev.detail.item.value;
    const entry = _objectSpread(_objectSpread({}, props.entry), {}, {
      measurement: _objectSpread(_objectSpread({}, props.entry.measurement), {}, {
        retentionBucketIndex
      })
    });
    props.updateEntry(Action.Edit, entry);
  };
  const handleAttributionSelection = (_ref: CustomEvent) => {
    let {
      detail
    }: CustomEvent = _ref;
    const entry = _objectSpread(_objectSpread({}, props.entry), {}, {
      measurement: _objectSpread(_objectSpread({}, props.entry.measurement), {}, {
        attributionSelection: detail.item.value
      })
    });
    props.updateEntry(Action.Edit, entry);
  };
  const breakdownAttributionLabel = props.sectionProps.breakdownAttributionLabeler ? print(props.sectionProps.breakdownAttributionLabeler(print((_getRetentionMetricAt = getRetentionMetricAttributionItems(props.entry).find(entry => entry.isSelected)) === null || _getRetentionMetricAt === void 0 ? void 0 : _getRetentionMetricAt.label) || "...")) : "...";
  const multiAttribution = getMultiAttributionFromEntry(props.entry);
  const isMultiAttributionOpen = props.activePart === EntryPart.MultiAttribution;
  const COUNT_TYPE_MAPPING = {
    [RETENTION_MATH_TYPES.RETENTION_RATE]: RetentionCountType.RetentionRate,
    [RETENTION_MATH_TYPES.UNIQUE]: RetentionCountType.Unique,
    [RETENTION_MATH_TYPES.PROPERTY_AVERAGE]: RetentionCountType.PropertyAverage,
    [RETENTION_MATH_TYPES.PROPERTY_SUM]: RetentionCountType.PropertySum
  };
  return <div className={clsx("mp-metric-entry-measurement", {
    'has-dg-select': showMetricDataGroupSelect
  })} data-sentry-component="MeasurementBlock" data-sentry-source-file="index.tsx">
      <div className='mp-metric-entry-measurement-inner'>
        {props.metricUnitsButton}
        {showMetricDataGroupSelect && <DataGroupSelect selectedDataGroup={dataGroupId} onSelect={id => {
        const entry = _objectSpread(_objectSpread({}, props.entry), {}, {
          measurement: _objectSpread(_objectSpread({}, props.entry.measurement), {}, {
            dataGroupId: id
          })
        });
        props.updateEntry(Action.Edit, entry);
      }} />}
        <CountQueryBlock className='count-menu' elref='countBlock' metricType={props.entry.behavior.type} dataGroupId={dataGroupId} dataGroups={Object.values(dataGroupStore.value)} projectId={props.sectionProps.projectId} countUsersOnceState={props.sectionProps.canUseMultiAttribution ? CountUsersOnceState.Required : props.sectionProps.countUsersOnceState} selected={{
        countType: COUNT_TYPE_MAPPING[props.entry.measurement.aggregationOperator],
        aggregationOperator: props.entry.measurement.aggregationOperator,
        property: props.entry.measurement.property,
        countUsersOnceType: props.entry.measurement.countUsersOnceType
      }} eventNames={[(_props$entry$behavior = props.entry.behavior.behaviors[1]) === null || _props$entry$behavior === void 0 ? void 0 : _props$entry$behavior.name]} trackName='retention' userId={props.sectionProps.userId} workspaceId={props.sectionProps.workspaceId} onSelect={handleRetentionCountBySelected} includeCustomProperties={props.sectionProps.includeCustomProperties} showBorrowedProperties={props.sectionProps.showBorrowedProperties} withDataGroupSelect={showMetricDataGroupSelect} data-sentry-element="CountQueryBlock" data-sentry-source-file="index.tsx" />

        {props.sectionProps.chartType === ChartType.RetentionCurve ? <SelectReact alwaysShowCaret theme={SelectTheme.Tertiary} size={ButtonSize.Small} menuAlignment={Directions.Right} menuWidth={184} disableFirstItemPadding elref='retentionBucketIndexSelect' sections={[{
        label: t("query-builder.retention.groups.title"),
        icon: "info-xs",
        tooltip: {
          'max-width': "120px",
          placement: Placement.Right,
          text: t("query-builder.retention.groups.tooltip")
        },
        items: [{
          label: t("query-builder.retention.groups.all"),
          isSelected: true,
          value: null
        }]
      }]} /> : <SelectReact alwaysShowCaret theme={SelectTheme.Tertiary} size={ButtonSize.Small} menuAlignment={Directions.Right} menuWidth={184} disableFirstItemPadding elref='retentionBucketIndexSelect' sections={[{
        label: t("query-builder.retention.groups.title"),
        icon: "info-xs",
        tooltip: {
          'max-width': "120px",
          placement: Placement.Right,
          text: t("query-builder.retention.groups.tooltip")
        },
        items: props.entry.measurement.retentionBuckets
      }]} onChange={handleRetentionBucketIndexSelected} />}
      </div>

      {!props.sectionProps.canUseMultiAttribution && props.sectionProps.canUseBreakdownAttribution && <div className='mp-metric-entry-measurement-inner'>
          <SelectReact elref='attributionSelect' alwaysShowCaret sections={[{
        items: getRetentionMetricAttributionItems(props.entry)
      }]} label={breakdownAttributionLabel} selectedOption='' size={ButtonSize.Small} theme={SelectTheme.Tertiary} menuWidth={0} tabIndex={0} experimentalPositioning onChange={handleAttributionSelection} />
        </div>}
      {props.sectionProps.canUseMultiAttribution && multiAttribution && <div className='mp-metric-entry-measurement-inner'>
          <SelectReact className='subitem-select.multi-attribution-type' elref='multiAttributionSelector' alwaysShowCaret label={print(getMultiAttributionLabel(props.entry, isMultiAttributionOpen))} title={isMultiAttributionOpen ? "" : print(getMultiAttributionTitle(props.entry))} open={isMultiAttributionOpen} theme={SelectTheme.Tertiary} size={ButtonSize.Small} onMenuChange={ev => props.setActivePart(EntryPart.MultiAttribution, ev.detail.isOpen ? "open" : "close")} tooltip={{
        text: "".concat(print(getMultiAttributionTitle(props.entry)), " ").concat(breakdownAttributionLabel, "."),
        size: DisplaySize.Medium
      }}>
            <div slot='body'>
              {isMultiAttributionOpen && <MultiAttributionMenu onCancel={() => props.setActivePart(EntryPart.MultiAttribution, "close")} onChange={ma => props.updateEntry(Action.Edit, getUpdatedMultiAttribution(props.entry, ma))} onDelete={() => props.updateEntry(Action.Edit, getUpdatedMultiAttribution(props.entry, null))} isSupportedMultiAttributionType={type => isSupportedMultiAttributionTypeForEntry({
            entry: props.entry,
            multiAttributionType: type,
            metricsResource: metrics,
            behaviorsResource: behaviors
          })} showMultiAttributionType={type => [MultiAttributionType.LastTouch, MultiAttributionType.FirstTouch, MultiAttributionType.Participation].includes(type)} metricIndex={props.index} multiAttribution={multiAttribution || DefaultMultiAttribution} projectIsFreePlan={props.sectionProps.projectIsFreePlan} />}
            </div>
          </SelectReact>
        </div>}
    </div>;
}
export function BehaviorBlock(props: EntryRowProps<MetricEntry>) {
  const behaviors = useBehaviors();
  const {
    t
  } = useTranslation();
  const hasMetricLevelDataGroups = props.sectionProps.metricLevelDataGroups;
  const dataGroupId = getFunnelOrRetentionDataGroupId({
    props
  });
  const handleEntryUpdate = (updates: EntrySectionUpdates<QueryEventEntry>) => {
    const {
      entries
    } = updates;
    const entryBehaviors: MetricEntryBehavior[] = entries.map(entry => ({
      id: entry.event.custom ? entry.event.id : null,
      type: entry.event.custom ? MetricType.CustomEvent : MetricType.Event,
      name: entry.event.value,
      filters: entry.filters,
      filtersDeterminer: entry.filtersOperator === FiltersOperator.Or ? "any" : "all"
    }));
    const entry: MetricEntry = _objectSpread(_objectSpread({}, props.entry), {}, {
      hasUnsavedChanges: true,
      behavior: _objectSpread(_objectSpread({}, props.entry.behavior), {}, {
        behaviors: entryBehaviors
      })
    });

    // need to pass in `getEntries(true)` because we maybe editing the stagingRow
    // After drag and drop, index can change
    const index = props.getEntries(true).findIndex(el => el.entryKey === entry.entryKey);
    props.updateEntry(Action.Edit, entry, {
      index
    });
  };
  const handleSettingsChanged = (update: RetentionQuerySettingsUpdate) => {
    const entry: MetricEntry = _objectSpread(_objectSpread({}, props.entry), {}, {
      hasUnsavedChanges: true,
      behavior: _objectSpread(_objectSpread({}, props.entry.behavior), {}, {
        retentionUnboundedMode: update.unboundedMode
      }),
      measurement: _objectSpread(_objectSpread({}, props.entry.measurement), {}, {
        retentionCumulative: Boolean(update.retentionCumulative)
      })
    });
    props.updateEntry(Action.Edit, entry);

    // TODO: emit track event
  };
  const handleRetentionUnitChanged = (update: RetentionUnitUpdate) => {
    const {
      retentionUnit
    } = update.detail;

    // TODO(CC): When the chart type is retention curve, changing the retention unit or bucket sizes
    // of a retention metric changes the retention units of all the other existing retention metrics.
    // Tune this later when we find a better solution to handle this.
    if (props.currentChartType === ChartType.RetentionCurve) {
      const entries = props.getEntries();
      entries.forEach((entry, index) => {
        if (isMetricEntry(entry) && entry.behavior.type === MetricType.Retention) {
          const updatedEntry: MetricEntry = _objectSpread(_objectSpread({}, entry), {}, {
            hasUnsavedChanges: true,
            behavior: _objectSpread(_objectSpread({}, entry.behavior), {}, {
              retentionUnit,
              retentionCustomBucketSizes: []
            }),
            measurement: _objectSpread(_objectSpread({}, entry.measurement), !isEqual(entry.behavior.retentionUnit, retentionUnit) ? {
              retentionBucketIndex: 0
            } : {})
          });
          props.updateEntry(Action.Edit, updatedEntry, {
            index
          });
        }
      });
      return;
    }
    const entry: MetricEntry = _objectSpread(_objectSpread({}, props.entry), {}, {
      hasUnsavedChanges: true,
      behavior: _objectSpread(_objectSpread({}, props.entry.behavior), {}, {
        retentionUnit,
        retentionCustomBucketSizes: []
      }),
      measurement: _objectSpread(_objectSpread({}, props.entry.measurement), !isEqual(props.entry.behavior.retentionUnit, retentionUnit) ? {
        retentionBucketIndex: 0
      } : {})
    });
    props.updateEntry(Action.Edit, entry);
  };
  const handleBucketSizesApplied = (update: RetentionBucketSizeUpdate) => {
    const {
      retentionUnit,
      bucketSizes
    } = update.detail;

    // TODO(CC): When the chart type is retention curve, changing the retention unit or bucket sizes
    // of a retention metric changes the retention units of all the other existing retention metrics.
    // Tune this later when we find a better solution to handle this.
    if (props.currentChartType === ChartType.RetentionCurve) {
      const entries = props.getEntries();
      entries.forEach((entry, index) => {
        if (isMetricEntry(entry) && entry.behavior.type === MetricType.Retention) {
          const updatedEntry: MetricEntry = _objectSpread(_objectSpread({}, entry), {}, {
            hasUnsavedChanges: true,
            behavior: _objectSpread(_objectSpread({}, entry.behavior), {}, {
              retentionUnit,
              retentionCustomBucketSizes: bucketSizes
            }),
            measurement: _objectSpread(_objectSpread({}, entry.measurement), !isEqual(entry.behavior.retentionUnit, retentionUnit) ? {
              retentionBucketIndex: 0
            } : {})
          });
          props.updateEntry(Action.Edit, updatedEntry, {
            index
          });
        }
      });
      return;
    }
    const entry: MetricEntry = _objectSpread(_objectSpread({}, props.entry), {}, {
      hasUnsavedChanges: true,
      behavior: _objectSpread(_objectSpread({}, props.entry.behavior), {}, {
        retentionUnit,
        retentionCustomBucketSizes: bucketSizes
      }),
      measurement: _objectSpread(_objectSpread({}, props.entry.measurement), !isEqual(props.entry.behavior.retentionUnit, retentionUnit) ? {
        retentionBucketIndex: 0
      } : {})
    });
    props.updateEntry(Action.Edit, entry);
  };
  const handleToggleRetentionAlignment = (update: RetentionAlignmentUpdate) => {
    const {
      retentionAlignmentType
    } = update.detail;
    const entry: MetricEntry = _objectSpread(_objectSpread({}, props.entry), {}, {
      hasUnsavedChanges: true,
      behavior: _objectSpread(_objectSpread({}, props.entry.behavior), {}, {
        retentionAlignmentType
      })
    });
    props.updateEntry(Action.Edit, entry);
  };
  const handleToggleCohortize = (update: RetentionCohortizeUpdate) => {
    const {
      disableCohortize
    } = update.detail;
    const entry: MetricEntry = _objectSpread(_objectSpread({}, props.entry), {}, {
      hasUnsavedChanges: true,
      behavior: _objectSpread(_objectSpread({}, props.entry.behavior), {}, {
        disableCohortize
      })
    });
    props.updateEntry(Action.Edit, entry);
  };
  const entries = props.entry.behavior.behaviors.map(behavior => _objectSpread({
    entryIndexLabelToggle: props.entry.behavior.entryIndexLabelToggle,
    event: {
      custom: behavior.type === MetricType.CustomEvent,
      id: behavior.id,
      label: renameEvent(behavior.name) || "",
      renamed: behavior.renamed,
      value: behavior.name
    },
    filters: behavior.filters,
    filtersOperator: behavior.filtersDeterminer === "any" ? FiltersOperator.Or : FiltersOperator.And,
    type: ResourceType.Event
  }, hasMetricLevelDataGroups ? {
    dataGroupId
  } : {}) as QuerySuperEntry);
  const isPlaceholder = helpers.isPlaceholder(props);
  return <div className='mp-metric-entry-behavior' data-sentry-component="BehaviorBlock" data-sentry-source-file="index.tsx">
      <QueryEntrySectionReact key='retentionEntries' elref='metricEntry' {...props.nestedSectionParams} autoactivatePlaceholders={props.sectionProps.reportName !== ReportName.Insights ? false : isPlaceholder || !hasSavedRetentionBehaviors({
      behaviors
    })} measurementBlock={props.measurementBlock} allowCohortFilter={false} emptyPlaceholder={{
      entryIndexLabelToggle: props.entry.behavior.entryIndexLabelToggle,
      event: {
        custom: false,
        id: null,
        label: "",
        renamed: null,
        value: null
      },
      filters: [],
      filtersOperator: FiltersOperator.And,
      type: ResourceType.Event
    }} disableAddEntry minEntries={props.entry.behavior.type === MetricType.Retention ? 2 : 1} rowDraggable rowIndex={props.index} rowLimit={props.entry.behavior.type === MetricType.Retention ? 2 : 1} rowTypes={[ResourceType.Event]} rowLabelType={RowLabelType.Numeric} reportName={ReportName.Retention} showAllEvents={false} showAnyEvent showTopEvents={false} showSessions={false} otherFilterOptions={[]} entries={entries} onUpdate={handleEntryUpdate} data-sentry-element="QueryEntrySectionReact" data-sentry-source-file="index.tsx" />
      <div className='criteria'>
        {props.entry.behavior.type === MetricType.Retention ? <RetentionCriteriaReact unboundedMode={props.entry.behavior.retentionUnboundedMode} retentionUnit={props.entry.behavior.retentionUnit} bucketSizes={props.entry.behavior.retentionCustomBucketSizes} retentionAlignmentType={props.entry.behavior.retentionAlignmentType} dataGroupId={dataGroupId} disableCohortize={props.entry.behavior.disableCohortize} chartType={props.currentChartType} onChangeSetting={ev => handleSettingsChanged(ev.detail)} onChangeUnit={handleRetentionUnitChanged} onApplyBucketSizes={handleBucketSizesApplied} onToggleRetentionAlignment={handleToggleRetentionAlignment} onToggleRetentionCohortize={handleToggleCohortize} /> : <div className={styles.retentionQuerySettings}>
            <SectionReact className={styles.retentionQuerySection} headerTitle={t("retention.frequency-criteria")} nonCollapsible>
              <div>
                <RetentionQuerySettingsReact retentionType={props.entry.behavior.retentionType} countingMethod={getRetentionCountingMethod(props.entry)} oldStyle onChange={handleSettingsChanged} />
              </div>
            </SectionReact>
          </div>}
      </div>
    </div>;
}
function EditControlsBlock(props: {
  entry: MetricEntry;
  handleReset: () => void;
  handleSaveBehavior: (saveAsNew: boolean, previouslyExisting: boolean) => void;
  editableState: EditableState;
}) {
  const {
    canEdit,
    canSave,
    isSaved,
    isSaving,
    saveDisabledMessage
  } = props.editableState;
  return <div className='mp-metric-entry-edit-controls' data-sentry-component="EditControlsBlock" data-sentry-source-file="index.tsx">
      <EditControls resetTooltip='Reverts the behavior to its previously saved state' isSaved={isSaved} isSaving={isSaving} canSave={canSave} canEdit={canEdit} canReset={canSave && isSavedBehavior(props.entry)} saveDisabledMessage={saveDisabledMessage} entityType={_ref2 => {
      let {
        t
      } = _ref2;
      return t("query-builder.metrics.behavior");
    }} onReset={props.handleReset} onSave={() => props.handleSaveBehavior(false, isSavedBehavior(props.entry))} onClone={() => props.handleSaveBehavior(true, isSavedBehavior(props.entry))} data-sentry-element="EditControls" data-sentry-source-file="index.tsx" />
    </div>;
}